import React from 'react';
import { Table } from 'reactstrap';
import { EffectsModal } from '../EffectsModal';

export const HousesDamagedDescriptionModal = ({ title }) => EffectsModal({
  title,
  valid: '0 to 4',
  content: (
    <div>
      <p>
        For those events not offering an exact number of houses damaged, the
        following four-level scale was used to classify the damage and was
        listed in the Houses Damaged column. If the actual number of houses
        destroyed was listed, a descriptor was also added for search purposes.
      </p>
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">0</th>
            <td>None</td>
          </tr>
          <tr>
            <th scope="row">1</th>
            <td>Few (~1 to 50 houses)</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Some (~51 to 100 houses)</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Many (101 to 1000 houses)</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>Very Many (~over 1000 houses)</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
});
